/* eslint-disable class-methods-use-this */
import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { postLayDcAmendPlan, validateLayDcAmendPlan } from '../../../../../../../global/ducks/benadmin-api';
import { PensionPlanTypes } from '../../../plan-history/plan-history-models';
import { LayDcPlanAdoptionContentModel, LayDcPlanFormModel, PlanSubmitRequest } from '../../models/plan-adoption-form-models';
import { IPlanSubmitRequest, IQccoStatusDto } from '../../models/plan-adoption-requests';
import { GetAmendLayDcFormContentModel } from '../plan-amend-helper';
import { LayDcReviewWizard } from './lay-dc-review-wizard';

export class LayDcAmendReviewWizard extends LayDcReviewWizard {

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();
        const amendCommonFormContentModel = GetAmendLayDcFormContentModel(content, institutionSettings);
        const requiresIndemnification = this.isIndemnificationRequired();

        return {
            ...amendCommonFormContentModel,
            gpsType: GpsType.LayDcAmendReview,          
            docuSignSubject: institutionSettings?.amendLayDCDocuSignSubject,
            docuSignFinishText: institutionSettings?.amendLayDCDocusignFinishText,
            docuSignTemplateId: requiresIndemnification ? institutionSettings?.amendIndemnifyLayDCDocuSignTemplateId : institutionSettings?.amendLayDCDocuSignTemplateId,
        };
    }

    onSuccessQueryParams() {
        return `?formType=${this.wizardOptions?.formType}&form=${PensionPlanTypes.LayDc}&isamend=true`;
    }

    createSubmitModel(formValue: LayDcPlanFormModel): IPlanSubmitRequest {
        const adoptRequest: IPlanSubmitRequest = super.createSubmitModel(formValue);
        const qcco_status: IQccoStatusDto = adoptRequest?.qcco_status;
        const layDcPlan = adoptRequest?.dc_plan;
        const latestAmendmentAttributes = layDcPlan?.latest_amendment_attributes;
        const amendmentDate = formValue?.adoption_date;

        const request: IPlanSubmitRequest = {
            dc_amendment: {
                ...latestAmendmentAttributes,
                plan_id: formValue?.planId,
                amendment_date: amendmentDate,
                docusign_envelope_id: layDcPlan?.docusign_envelope_id,
                contribution_overrides: layDcPlan?.contribution_overrides,
            },
            qcco_status,
        };

        return request;
    }

    onValidateRequest(request: PlanSubmitRequest, onValidationSucess?: (request: PlanSubmitRequest) => void, onFailure?: () => any) {

        const formValues = request?.values as LayDcPlanFormModel;
        const payload = this.createSubmitModel(formValues);
        const planIdString = formValues?.planId?.toString();

        this.dispatch(validateLayDcAmendPlan(
            request?.clientId,
            planIdString,
            payload,
            () => onValidationSucess(request),
            onFailure),
        );
    }

    onSubmit(request: PlanSubmitRequest) {

        const formValues = request?.values as LayDcPlanFormModel;
        const payload = this.createSubmitModel(request?.values as LayDcPlanFormModel);
        const planIdString = formValues?.planId?.toString();

        this.dispatch(postLayDcAmendPlan(request?.clientId, planIdString, payload, () => this.onSuccess(request)));
    }

    isIndemnificationRequired(): boolean {
        return false;
    }
}